let warterMark = {}

let setWaterMark = (waterMarkMsg) => {
  let id = '1.23452384164.123412415'

  if (document.getElementById(id) !== null) {
    document.body.removeChild(document.getElementById(id))
  }

  let can = document.createElement('canvas')
  can.width = 350
  can.height = 160

  let cans = can.getContext('2d')
  cans.rotate(-20 * Math.PI / 180)
  cans.font = '17px Vedana'
  cans.fillStyle = '#bfbfbf' //字体颜色
  cans.textAlign = 'left'
  cans.textBaseline = 'Middle'
  cans.fillText(waterMarkMsg, 60, 160)

  let div = document.createElement('div')
  div.id = id
  div.style.pointerEvents = 'none'
  div.style.top = '70px'
  div.style.left = '0px'
  div.style.opacity = 0.5 //字体颜色深浅
  div.style.position = 'absolute'
  div.style.zIndex = '100000'
  div.style.position = 'fixed'
  div.style.width = document.documentElement.clientWidth + 'px'
  div.style.height = document.documentElement.clientHeight + 'px'
  div.style.background = 'url(' + can.toDataURL('image/png') + ') left top repeat'
  document.body.appendChild(div)
  return id
}

warterMark.set = (waterMarkMsg) => {
  let id = setWaterMark(waterMarkMsg)
  /*setInterval(() => {
    if (document.getElementById(id) === null) {
      id = setWaterMark(str);
    }
  }, 500);*/
  window.onresize = () => {
	 setWaterMark(waterMarkMsg)
  }
}

export default warterMark


// WEBPACK FOOTER //
// ./src/utils/waterMark.js